import React from 'react'
import kalkulackaImg from "../assets/img/essox/ESSOX_kalkulacka.jpg"
import useFetchRest from "../hooks/useFetchRest";
import {ESSOX_CALCULATOR_URL, ESSOX_PROPOSAL_URL, PROXY_URL} from "../Constants";

function EssoxButtons({price, productId}) {
    const paramsCalc = {price: price, productId: productId}
    const paramsProposal = {
        firstName: "",
        surname: "",
        mobilePhonePrefix: "",
        mobilePhoneNumber: "",
        email: "",
        price: price,
        productId: productId,
        orderId: "",
        customerId: "",
        shippingAddress: {
            street: "",
            houseNumber: "",
            city: "",
            zip: ""
        },
        callbackUrl: "",
        callbackType: "",
        spreadedInstalments: false
    };

    const calcFetch = useFetchRest(PROXY_URL + ESSOX_CALCULATOR_URL, paramsCalc);
    const propFetch = useFetchRest(PROXY_URL + ESSOX_PROPOSAL_URL, paramsProposal);

    // Handle loading states
    if (calcFetch.loading || propFetch.loading) {
        return <></>; // Return blank while loading
    }

    // Handle errors
    if (calcFetch.error || propFetch.error) {
        return <p>V tuto chvíli nelze využít ESSOX službu</p>;
    }


    if (!calcFetch.data || !calcFetch.data.redirectionUrl || !propFetch.data || !propFetch.data.redirectionUrl) {
        console.warn("Missing redirectionUrl in API response:", calcFetch.data);
        return <p>Essox kalkulačka není k dispozici</p>;
    }

    return (
        <div className="w-50 d-flex align-items-center gap-3 p-2">
            <a href={calcFetch.data.redirectionUrl} target="_blank" rel="noopener noreferrer"
               className="d-inline-block">
                <img
                    src={kalkulackaImg}
                    alt="Essox kalkulacka"
                    className="img-fluid"
                    style={{maxWidth: '250px'}}
                />
            </a>

            <a href={propFetch.data.redirectionUrl} target="_blank" rel="noopener noreferrer"
               className="submit_btn d-inline-block text-white text-decoration-none px-4 py-2"
               style={{
                   fontSize: '20px',
                   fontWeight: 'bold',
                   borderRadius: '8px',
                   boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.2)',
                   transition: 'background-color 0.3s ease'
               }}
               onMouseOver={(e) => e.target.style.backgroundColor = '#c89a12'}
               onMouseOut={(e) => e.target.style.backgroundColor = '#faba00'}>
                Sjednat
            </a>
        </div>
    );
}

export default EssoxButtons
